<template>
<div style=width:100%>

    <input v-model="newTask" type="text" placeholder="Add a task..." class="quick-input" style="margin-bottom:10px;background-color:white;" 
        @keypress.enter.exact.prevent="quickSaveTask(newTask)"/>

    <div v-for="task in tasks" tabindex="0" class="task selectable clickable hoverable" :class="{selected: isTaskSelected(task)}"  :key="task.key"
        @click.exact="selectSingle(task)"
        @dblclick="openTask(task)"
        @keydown.right="increment(task, 1)"
        @keydown.left="increment(task, -1)"
    >
        <div class="indicator">    
            <div style="float:right;margin-top:-1px;margin-right:-7px" @click.stop.prevent>
                <v-menu left offset-y>
                <template v-slot:activator="{ on }">
                <v-icon class="menu-icon" v-on="on">more_vert</v-icon>
                </template>
                <v-list>
                    <v-list-item @click="openTask(task)">
                        <v-list-item-title>Edit</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="toggleImportant(task)">
                        <v-list-item-title>
                            <span v-if="task.important">Not </span>Important
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="tasks.length > 1" @click.exact="deleteTask(task)">
                        <v-list-item-title>Delete</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="tasks.length == 1" @click="deleteTask(task, true)" >
                        <v-list-item-title>Delete + Stop Follow Up</v-list-item-title>
                    </v-list-item>
                </v-list>
                </v-menu>
            </div>

            <div style="display:flex" >
                <div @click.stop style="flex-basis:1%; margin-top:-22px;">
                    <v-checkbox @change="taskChecked(task)" />           
                </div>

                <div>
                    <span>{{task.title}}</span><flag v-if="task.important">Important</flag><br/>
                    <div v-if="daysTillDue(task) < 1" style="border-radius: 2px;margin-bottom:-1px;margin-right:2px;width:12px;height:12px;background-color:#ccc;display:inline-block" :class="dueIndicatorClass(task)"></div>
                    {{task.due | dueString}}<span style="font-size:11px;color:#aaa;margin-left:4px;">{{task.assigned | fullName}}</span>
                </div> 
            </div>

        </div>    
    </div> 

    <!-- Dialog Box -->
    <TaskDialog :task="taskDialog.model" :settings="taskDialog.settings" @save="saveTask" />

</div>
</template>

<script>

import DataHelpers from '../helpers/DataHelpers'
import DateHelpers from '../helpers/DateHelpers'
import { dateFormats } from '../helpers/DateHelpers'
import NumberHelpers from '../helpers/NumberHelpers'
import ListHelpers from '../helpers/ListHelpers'
import FirebaseHelpers from '../helpers/FirebaseHelpers'
import Utilities from '../helpers/Utilities'
import DialogBox from '../ui-elements/DialogBox'
import TaskDialog from '../ui-elements/TaskDialog'
import Flag from '../ui-elements/Flag'
import UserChooser from '../ui-elements/UserChooser'
import ContactHelpers from '../helpers/ContactHelpers'
import Scheduler from '../ui-elements/Scheduler'
import Vue from 'vue'
import ElementHelpers from '../helpers/ElementHelpers'
import { addDays, differenceInDays } from 'date-fns'
import StringHelpers from '../helpers/StringHelpers';
import AlertHelpers from '../helpers/AlertHelpers';

const SAFETY_TASK_TITLE = 'Please follow up'


export default {

data() {
    return {
    newTask: null,
    taskDialog: {
        settings: {
            visible: false,
            title: 'Task Details',
        },
        model: {
            key: null,
            title: null,
            due: null,
            assigned: {},
        }
    },        
    }
},

props: {
    
},

components:{
    DialogBox,
    TaskDialog,
    UserChooser,
    Scheduler,
    Flag,
},

computed: {
    tasks() {
        return this.$store.getters.tasks.filter(o => o.transactionKey == this.transactionKey)
        .sort( (a, b) => a.due > b.due)
        // .map(t => { return {...t, complete:false}})
    },
    user() {
        return this.$store.getters.user
    },
    // users() {
    //     return this.$store.getters.users
    // },
    transactionKey() {
        return this.$store.getters.transaction.key
    },
    nextBusinessDay() {
        DateHelpers.businessDaysFromNow(1).formatBackwards()
    },
    selectedTab() {
        return this.$store.getters.selectedTab
    },
    selectedTask() {
        return this.$store.getters.selectedTask
    }
},

methods: {
    increment(task, days) {
        // if(task != this.selectedTask)
        //     return

        let dueDate = DateHelpers.backwardsToDate(task.due)
        dueDate = DateHelpers.businessDaysAdd(dueDate, days)
        task.due = DateHelpers.dateToBackwards(dueDate)
        this.saveTask(task)
    },

    fullName(contact) {
        return ContactHelpers.fullName(contact)
    },

    dueIndicatorClass(task) {
        let days = this.daysTillDue(task)
        if(days == 0)
            return "primary darken-1"
        else if(days < 0)
            return "red darken-2"
    },

    daysTillDue(task) {
        if(!task.due)
            return null

        // return moment(task.due, 'YYYY-MM-DD').diff(moment().startOf('day'))
        return differenceInDays(DateHelpers.backwardsToDate(task.due), new Date() )
    },

    openTask(task) {
        this.taskDialog.model = {...task} || {
            due: this.nextBusinessDay,
            assigned: this.$store.getters.user,
            clients: this.$store.getters.transaction.clients,
        }

        this.taskDialog.settings.visible = true
    },

    changeDueDate(task, days) {
        ListHelpers.selectedOrClicked(task, this.selectedTasks).forEach(selected => {
            //selected.due = moment(selected.due, 'YYYY-MM-DD').add(days, 'days').format('YYYY-MM-DD')
            const selectedDue = DateHelpers.backwardsToDate(selected.due)
            const newDue = addDays(selectedDue, days)
            selected.due = format(newDue, dateFormats.BACKWARDS)
        })    
    },

    taskChecked(task) {
        setTimeout( () => {
            Vue.nextTick( () => {
                this.completeTask(task)
            })
        }, 700)
    },

    isTaskSelected(task) {
        if(!this.selectedTask || !task)
            return false
        if(task.key == this.selectedTask.key)
            return true
        return false
    },

    completeTask(task) {  
        let comment = {
            text: task.title,
            sectionKey: task.sectionKey || null,
            tabKey: this.selectedTab.key || null,
            complete: true,
        }
        this.$store.dispatch('saveTransactionComment', comment)
        this.deleteTask(task)
    },

    toggleImportant(task) {
        task.important = !task.important
        this.saveTask(task)
    },

    selectSingle(task) {
        console.log('selectSingle', task)
        let newTask
        if(this.isTaskSelected(task))
            newTask = null
        else
            newTask = task
        this.$store.dispatch('selectTask', newTask)
    },

    quickSaveTask(taskTitle) {

        if(taskTitle.length < 3)
            return

        Utilities.log('tasks > quickSaveTask')


        let task = {
            tabKey: (this.selectedTab ? this.selectedTab.key : null),
            sectionTitle: this.selectedSection ? this.selectedSection.title : null,
            title: taskTitle,
            assigned: this.user,
            due: this.nextBusinessDay,
            clients: this.$store.getters.transaction.clients,
            lender: ElementHelpers.getValueFromName('lender')
        }     

        let periodObj = DateHelpers.findTimeframeInString(taskTitle)
        if(periodObj.found) {
            task.due = DateHelpers.dateToBackwards(periodObj.date)
            task.title = periodObj.remaining
            AlertHelpers.showAlert('Scheduled for ' + periodObj.words)
        }

        this.$store.dispatch('saveTask', task)
    
        this.newTask = ''
        
        this.removeSafeguard()
    },

    saveTask(task) {
        console.log('tasks > saveTask')

        if(task.title)

        task.lender = ElementHelpers.getValueFromName('lender')
        
        this.$store.dispatch('saveTask', task)
        setTimeout(()=>{
            Utilities.clearProperties(task)
        },500)
      
        if(!task.title == SAFETY_TASK_TITLE)
            this.removeSafeguard()
    },

    removeSafeguard() {
        
        let safeTask = this.tasks.find(o => o.title == SAFETY_TASK_TITLE)
        if(safeTask && this.tasks.length > 1)
            this.deleteTask(safeTask, true)

    },

    deleteTask(task, force) {
        this.$store.dispatch('deleteTask', task)

        if(force)
            return

        if(!this.tasks.length) {
            this.saveTask({
                title: SAFETY_TASK_TITLE,
            })
        }
    },

    lineBreaks(str) {
        return str.replace(/\n/g, '<br/>')
    },

    stamp(item) {
        let stampString = DataHelpers.formatStamp(item.stamp)
        return stampString
    },

},

    watch: {

    },

created() {
    this.$store.dispatch('loadTasks')

    // //new to autocreate if tasks don't exist...
    // setTimeout( () => {
    //     if(this.tasks.length < 1)
    //         this.saveTask({
    //             title: SAFETY_TASK_TITLE,
    //         })
    // },3000)

}
}
</script>

<style scoped>
.task {
    margin-bottom: 6px;
    color:#444;
    border-radius: 2px;
    font-size: 1em;
}

.task:focus {
    outline:none;
}

.selected {
    border: solid 1px #bbb;
    background-color: #ddd;
}

.textarea-subtle {
    padding:4px;
    padding-left:7px;
    border: solid 1px #c0c0c0;
    border-radius:3px;
    width:100%;
    height:70px;
}

.hoverable:hover {
    background-color: #eee !important
}

.selected.hoverable:hover {
    background-color: #ccc !important
}

</style>




// WEBPACK FOOTER //
// TransactionTasks.vue?3979855a